/** แชท's data in the query cache (apps/portal/src/chat): everything under it is fetched again when a room changes */
export const chatRoomsKey = ['chat'] as const
